import React, { useEffect, useState } from 'react';
import { FaAngleRight, FaAngleLeft } from "react-icons/fa6"; 
import SummaryApi from '../common';

const BannerProduct = () => {
    const [currentImage, setCurrentImage] = useState(0);
    const [advertisements, setAdvertisements] = useState([]);

    const fetchAdvertisements = async () => {
        try {
            const response = await fetch(SummaryApi.allAdvertisements.url, {
                method: SummaryApi.allAdvertisements.method,
                credentials: 'include',
                headers: {
                    "Content-Type": 'application/json'
                }
            });
            const responseData = await response.json();
            setAdvertisements(responseData.data || []);
           
        } catch (error) {
        }
    };

    useEffect(() => {
        fetchAdvertisements();
    }, []);

    const nextImage = (e) => {
        e?.stopPropagation()
        e?.preventDefault()
        if (advertisements.length - 1 > currentImage) {
            setCurrentImage((prev) => prev + 1);
        }
        else if(advertisements.length - 1 === currentImage){
            setCurrentImage(0);
        }
    };

    const preveImage = (e) => {
        e?.stopPropagation()
        e?.preventDefault()

        if (currentImage !== 0) {
            setCurrentImage((prev) => prev - 1);
        }
        else{
            setCurrentImage(advertisements.length - 1);
        }
    };

    useEffect(() => {
        const interval = setInterval(() => {
            if (advertisements.length - 1 > currentImage) {
                nextImage();
            } else {
                setCurrentImage(0);
            }
        }, 5000);

        return () => clearInterval(interval);
    }, [currentImage, advertisements]);

    const handleDotClick = (index) => {
        setCurrentImage(index);
    };

    return (
        <div className='container mx-auto px-4 rounded'>
<div className={`h-70 md:h-80 w-full bg-slate-200 relative`}>
    {advertisements?.at(currentImage)?.link !== "" ? (
        <a href={advertisements?.at(currentImage)?.link} target="_blank" rel="noopener noreferrer">
            {/* Banner content */}
            {/* Desktop view images */}
            <div className='hidden md:flex h-full w-full overflow-hidden'>
            <div className='absolute z-10 h-full w-full md:flex items-center'>
                <div className='flex justify-between w-full text-2xl'>
                    <div onClick={(e) => preveImage(e)} className='bg-white shadow-md rounded-full p-1 cursor-pointer'>
                        <FaAngleLeft />
                    </div>
                    <div onClick={(e) => nextImage(e)} className='bg-white shadow-md rounded-full p-1 cursor-pointer'>
                        <FaAngleRight />
                    </div>
                </div>
            </div>
                {advertisements.map((ad, index) => (
                    <div
                        className='w-full h-full min-w-full min-h-full transition-all relative'
                        key={index}
                        style={{ transform: `translateX(-${currentImage * 100}%)` }}
                    >
                        <img src={ad.desktopImage} alt={`Advertisement ${index}`} className='w-full h-full' />
                    </div>
                ))}
            </div>

            {/* Mobile view images */}
            <div className='flex h-full w-full overflow-hidden md:hidden'>
                {advertisements.map((ad, index) => (
                    <div
                        className='w-full h-full min-w-full min-h-full transition-all relative'
                        key={index}
                        style={{ transform: `translateX(-${currentImage * 100}%)` }}
                    >
                        <img src={ad.mobileImage} alt={`Advertisement ${index}`} className='w-full h-full object-cover' />
                    </div>
                ))}
                 {/* Mobile Navigation (show only in mobile view) */}
            <div className='absolute z-10 h-full w-full flex items-center md:hidden'>
                <div className='flex justify-between w-full text-2xl'>
                    <div onClick={(e) => preveImage(e)} className='bg-white shadow-md rounded-full p-1 cursor-pointer'>
                        <FaAngleLeft/> 
                    </div>
                    <div onClick={(e) => nextImage(e)} className='bg-white shadow-md rounded-full p-1 cursor-pointer'>
                        <FaAngleRight/> 
                    </div>
                </div>
            </div>
            </div>
           

        </a>
    ) : (
            <a>
            {/* Banner content */}

            {/* Desktop view images */}
            <div className='hidden md:flex h-full w-full overflow-hidden'>
            <div className='absolute z-10 h-full w-full md:flex items-center'>
                <div className='flex justify-between w-full text-2xl'>
                    <div onClick={(e) => preveImage(e)} className='bg-white shadow-md rounded-full p-1 cursor-pointer'>
                        <FaAngleLeft/>
                    </div>
                    <div onClick={(e) => nextImage(e)} className='bg-white shadow-md rounded-full p-1 cursor-pointer'>
                        <FaAngleRight/>
                    </div>
                </div>
            </div>
                {advertisements.map((ad, index) => (
                    <div
                        className='w-full h-full min-w-full min-h-full transition-all relative'
                        key={index}
                        style={{ transform: `translateX(-${currentImage * 100}%)` }}
                    >
                        <img src={ad.desktopImage} alt={`Advertisement ${index}`} className='w-full h-full' />
                    </div>
                ))}
            </div>

            {/* Mobile view images */}
            <div className='flex h-full w-full overflow-hidden md:hidden'>
                {advertisements.map((ad, index) => (
                    <div
                        className='w-full h-full min-w-full min-h-full transition-all relative'
                        key={index}
                        style={{ transform: `translateX(-${currentImage * 100}%)` }}
                    >
                        <img src={ad.mobileImage} alt={`Advertisement ${index}`} className='w-full h-full object-cover' />
                    </div>
                ))}
                 {/* Mobile Navigation (show only in mobile view) */}
            <div className='absolute z-10 h-full w-full flex items-center md:hidden'>
                <div className='flex justify-between w-full text-2xl'>
                    <div onClick={(e) => preveImage(e)} className='bg-white shadow-md rounded-full p-1 cursor-pointer'>
                        <FaAngleLeft/> 
                    </div>
                    <div onClick={(e) => nextImage(e)} className='bg-white shadow-md rounded-full p-1 cursor-pointer'>
                        <FaAngleRight/>
                    </div>
                </div>
            </div>
            </div>
           
            </a>
    )}
   
</div>

 


{/* Points indicator (dots) */}
<div className="flex justify-center space-x-2 mt-4">
    {advertisements.map((_, index) => (
        <div
            key={index}
            className={`w-3 h-3 rounded-full cursor-pointer ${index === currentImage ? 'bg-blue-900' : 'bg-gray-300'}`}
            onClick={() => handleDotClick(index)}
        />
    ))}
</div>
</div>

    );
};

export default BannerProduct;
